<template>
    <transition name="slide">
        <div class="bg-surface-secondary w-100">
            <header class="bg-surface-primary border-bottom">
                <div class="container-fluid py-4">
                    <div class="row align-items-center">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <h1 class="h4 ls-tight">Crear sucursal</h1>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="CREATE()" type="button" class="btn btn-h btn-success px-3">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Guardar</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main class="py-6 bg-surface-secondary">
                <div class="container-fluid max-w-screen-md vstack gap-3">
                    <div>
                        <small class="input-title">Nombre</small>
                        <input type="text" class="form-control form-control-sm" v-model="data.name" :class="errors.name ? 'is-invalid' : ''">
                        <small class="invalid-feedback" v-for="(error, index) in errors.name" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">País: </small>
                        <v-select v-model="data.country_id"
                            :items="countries"
                            item-text="name"
                            item-value="id"
                            hide-details
                            @change="PROVINCES"
                            class="form-control form-control-sm"
                            :class="errors.country_id ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.country_id" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Provincia: </small>
                        <v-select v-model="data.province_id"
                            :items="provinces"
                            item-text="name"
                            item-value="id"
                            hide-details
                            @change="CITIES"
                            class="form-control form-control-sm"
                            :class="errors.province_id ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.province_id" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Cuidad: </small>
                        <v-select v-model="data.city_id"
                            :items="cities"
                            item-text="name"
                            item-value="id"
                            hide-details
                            @change="DISTRICTS"
                            class="form-control form-control-sm"
                            :class="errors.city_id ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.city_id" :key="index">{{ error }}</small>
                    </div>
                    <div>
                        <small class="input-title">Distrito: </small>
                        <v-select v-model="data.district_id"
                            :items="districts"
                            item-text="name"
                            item-value="id"
                            hide-details
                            class="form-control form-control-sm"
                            :class="errors.district_id ? 'is-invalid' : ''">
                        </v-select>
                        <small class="invalid-feedback" v-for="(error, index) in errors.district_id" :key="index">{{ error }}</small>
                    </div> 
                </div>
            </main>
        </div>
    </transition>
</template>
<script>
export default{
    data(){
        return{
            data: {},
            errors: {},
            count: 0,
            countries: [],
            provinces: [],
            cities: [],
            districts: [],
        }
    },
    created(){
        this.COUNTRIES()
    },
    methods: {
        COUNTRIES: function(){
            axios({url: '/locations/countries', method: 'GET' })
            .then((resp) => {
                this.countries = resp.data
            })
        },
        PROVINCES: function(){
            axios({url: '/locations/provinces/'+ this.data.country_id, method: 'GET' })
            .then((resp) => {
                this.provinces = resp.data
            })
        },
        CITIES: function(){
            axios({url: '/locations/cities/'+ this.data.province_id, method: 'GET' })
            .then((resp) => {
                this.cities = resp.data
            })
        },
        DISTRICTS: function(){
            axios({url: '/locations/districts/'+ this.data.city_id, method: 'GET' })
            .then((resp) => {
                this.districts = resp.data
            })
        },
        CREATE: function(){
            let vue = this
            vue.count++
            if(vue.count == 1){
                vue.errors = {}
                setTimeout(() => {
                    axios({url: '/branch-offices', method: 'POST', data: vue.data })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        vue.$router.push({ name: 'BranchOfficeIndex' })
                    })
                    .catch((err) => {
                        if(err.response.status !== 422){
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.errors = err.response.data
                        }
                    })
                    .finally((resp)=>{
                        vue.count = 0
                    })
                }, 1000)
            }
        }
    }
}
</script>